import { Icon } from 'lucide-react'

import { type CustomLucideIconProps } from './props'

export function SolidAlertTriangleIcon ({ color = 'currentColor', ...props }: CustomLucideIconProps) {
  return (
    <Icon {...props} fill={color} stroke='none' iconNode={[]}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.7323 18.0022L13.7386 4.01311C13.5643 3.70555 13.3116 3.44974 13.0061 3.27175C12.7007 3.09377 12.3535 3 12 3C11.6465 3 11.2993 3.09377 10.9939 3.27175C10.6885 3.44974 10.4357 3.70555 10.2614 4.01311L2.26778 18.0022C2.09161 18.3074 1.99922 18.6536 2 19.006C2.00079 19.3583 2.0947 19.7042 2.27223 20.0085C2.44975 20.3129 2.70458 20.5648 3.01089 20.739C3.31719 20.9131 3.66408 21.0031 4.01639 20.9999H20.0036C20.3543 20.9996 20.6986 20.907 21.0021 20.7314C21.3056 20.5559 21.5576 20.3036 21.7328 19.9998C21.9079 19.6961 22.0001 19.3516 22 19.001C21.9999 18.6503 21.9076 18.3059 21.7323 18.0022ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V9ZM11 17C11 16.4477 11.4477 16 12 16H12.01C12.5623 16 13.01 16.4477 13.01 17C13.01 17.5523 12.5623 18 12.01 18H12C11.4477 18 11 17.5523 11 17Z'
      />
    </Icon>
  )
}
